import * as allTypes from 'constants/ActionTypes';

import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

const initialState = {};

const sortByOrder = (a, b) => a.order >= b.order;

const userGroupsReducer = (state, { payload: groups, meta }) => {
  const { dealerId } = meta;
  const data = groups.sort(sortByOrder).map(group => group.id);
  return { ...state, [dealerId]: data };
};

const userGroupsFromDealerReducer = (state, { payload: dealer }) => {
  if (dealer?.steps) {
    const data = Object.values(dealer.steps).flatMap(steps =>
      steps.filter(step => step?.userGroup).map(step => step.userGroup.id));

    return { ...state, [dealer.id]: uniq([...(state?.[dealer.id] ?? []), ...data]) };
  }
  return state;
};

const userGroupsPerDealersReducer = (state, { payload }) => {
  const userGroupsByDealer = payload.content.reduce((acc, cur) => {
    acc[cur.dealerId] = uniq([...(acc[cur.dealerId] || []), cur.id]);
    return acc;
  }, state);

  return { ...userGroupsByDealer };
};

const clearIds = () => initialState;

export default createReducer(initialState, {
  [types.CLEAR_USER_GROUP_SELECT]: clearIds,
  [types.FETCH_USER_GROUPS_SUCCESS]: userGroupsReducer,
  [types.UPDATE_USER_GROUPS_SUCCESS]: userGroupsReducer,
  [allTypes.FETCH_DEALER_SUCCESS]: userGroupsFromDealerReducer,
  [types.FETCH_SELECTED_USER_GROUPS_SUCCESS]: userGroupsPerDealersReducer,
});
